<template>
  <div>
    <Report
      module="Cliente"
      name="Cliente"
      urlGet="/api/v1/crm/report/customer"
      :header="header"
      :filters="filters"
    />
  </div>
</template>

<script>
import Report from "@nixweb/nixloc-ui/src/component/report/Report";

export default {
  name: "ReportCustomerView",
  components: {
    Report,
  },
  data() {
    return {
      header: [
        {
          title: "Cli..For",
          field: "supplierCustomerName",
          fieldOrderBy: "SupplierCustomerName",
          show: false,
        },
        {
          title: "Tipo",
          field: "typePersonName",
          fieldOrderBy: "TypePersonName",
          show: true,
        },
        {
          title: "Razão Social/Nome",
          field: "companyName",
          fieldOrderBy: "CompanyName",
          show: true,
          initialOrderBy: true,
          styleHeader: "width:250px;",
          styleBody:
            "max-width: 240px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
        },
        {
          title: "Fantasia/Apelido",
          field: "tradeName",
          fieldOrderBy: "TradeName",
          show: true,
          styleHeader: "width:200px;",
          styleBody:
            "max-width: 190px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
        },
        {
          title: "CNPJ/CPF",
          field: "document",
          fieldOrderBy: "Document",
          show: true,
          styleHeader: "width:140px;",
          styleBody: "max-width: 130px;",
        },
        {
          title: "IE/RG",
          field: "stateInscription",
          fieldOrderBy: "StateInscription",
          show: false,
          styleHeader: "width:120px;",
          styleBody: "max-width: 110px;",
        },
        {
          title: "IM",
          field: "municipalInscription",
          fieldOrderBy: "MunicipalInscription",
          show: false,
          styleHeader: "width:100px;",
          styleBody: "max-width: 90px;",
        },
        {
          title: "Categoria",
          field: "customerCategoryName",
          fieldOrderBy: "CustomerCategoryName",
          show: false,
          styleHeader: "width:160px;",
          styleBody:
            "max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
        },
        {
          title: "Origem",
          field: "originCustomerName",
          fieldOrderBy: "OriginCustomerName",
          show: false,
          styleHeader: "width:160px;",
          styleBody:
            "max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
        },
        {
          title: "Status",
          field: "statusName",
          fieldOrderBy: "StatusName",
          show: true,
          styleHeader: "width:90px; text-align:center;",
          styleBody: "max-width: 80px; text-align:center;",
        },
        {
          title: "Telefone",
          field: "phone",
          fieldOrderBy: "Phone",
          show: false,
          styleHeader: "width:130px;",
          styleBody: "max-width: 120px;",
        },
        {
          title: "Site",
          field: "webSite",
          fieldOrderBy: "WebSite",
          show: false,
          styleHeader: "width:160px;",
          styleBody:
            "max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
        },
        {
          title: "E-mail",
          field: "email",
          fieldOrderBy: "Email",
          show: false,
          styleHeader: "width:200px;",
          styleBody:
            "max-width: 190px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
        },
        {
          title: "Observações",
          field: "observation",
          fieldOrderBy: "Observation",
          show: false,
          styleHeader: "width:220px;",
          styleBody:
            "max-width: 210px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
        },
      ],
      filters: [
        {
          type: "options",
          title: "Cliente?",
          field: "IsCustomer",
          options: [
            { text: "Sim", value: true },
            { text: "Não", value: false },
          ],
          value: [],
        },
        {
          type: "options",
          title: "Fornecedor?",
          field: "IsSupplier",
          options: [
            { text: "Sim", value: true },
            { text: "Não", value: false },
          ],
          value: [],
        },
        {
          type: "options",
          title: "Tipo",
          field: "TypePerson",
          options: [
            { text: "Física", value: 1 },
            { text: "Jurídica", value: 2 },
          ],
          value: [],
        },
        {
          type: "text",
          title: "Razão Social/Nome",
          field: "CompanyName",
          value: "",
        },
        {
          type: "text",
          title: "Fantasia/Apelido",
          field: "TradeName",
          value: "",
        },
        {
          type: "text",
          title: "CNPJ/CPF",
          field: "Document",
          value: "",
        },
        {
          type: "text",
          title: "IE/RG",
          field: "StateInscription",
          value: "",
        },
        {
          type: "text",
          title: "IM",
          field: "MunicipalInscription",
          value: "",
        },
        {
          type: "multiOptions",
          title: "Categoria",
          field: "CategoryCustomerName",
          url: "/api/v1/crm/category-customer/select-all",
          propsParams: {},
          value: "",
        },
        {
          type: "multiOptions",
          title: "Origem",
          field: "OriginCustomerName",
          url: "/api/v1/crm/origin-customer/select-all",
          propsParams: {},
          value: "",
        },
        {
          type: "options",
          title: "Status",
          field: "Status",
          options: [
            { text: "Ativo", value: 1 },
            { text: "Inativo", value: 2 },
          ],
          value: [],
        },
        {
          type: "text",
          title: "Telefone",
          field: "Phone",
          value: "",
        },
        {
          type: "text",
          title: "Site",
          field: "WebSite",
          value: "",
        },
        {
          type: "text",
          title: "E-mail",
          field: "Email",
          value: "",
        },
        {
          type: "text",
          title: "Observações",
          field: "Observation",
          value: "",
        },
      ],
    };
  },
};
</script>
